<div class="dnd">
  @if (label) {
    <div class="dnd-label">{{label}}</div>
  }

  <div class="dnd-area" (click)="fileInput.click()" appDragNDrop (onFileDropped)="onSelect($event)">

    <input #fileInput
      [multiple]="multiple"
      [accept]="mimeTypes"
      hidden
      type="file"
      (change)="onSelect($event.target.files); fileInput.value = null">

      @switch (true) {
        <!-- Empty -->
        @case (!value) {
          <div class="dnd-info">
            <div class="dnd-icon-container">
              <i class="icon-upload-cloud"></i>
            </div>
            <div class="dnd-details">
              <div class="dnd-caption">{{ caption }}</div>
              <div class="dnd-placeholder">{{ placeholder }}</div>
              <div class="dnd-description">
                Allowed types: {{ allowedTypes }}
                <app-validation-error [errors]="ngControl.errors"></app-validation-error>
              </div>
            </div>
          </div>
        }
        <!-- Single selected file -->
        @case (value && !multiple) {
          <div class="dnd-info">
            <div class="dnd-icon-container">
              <i class="icon-doc"></i>
            </div>
            <div class="dnd-details">
              <div class="dnd-caption">{{value['originalName'] || value.name}}</div>
              <div class="dnd-placeholder">{{ value.size | fileSizeConvert }}</div>
              @if (ngControl.errors) {
                <div class="dnd-description">
                  @if (ngControl.control.hasError('fileExtensions')) {
                    <div class="c-error">
                      Allowed file types: {{ngControl.errors['fileExtension']['allowedExtensions']}}
                    </div>
                  }
                  @if (ngControl.control.hasError('fileMaxSize')) {
                    <div class="c-error">
                      Maximum file size: {{ngControl.errors['fileMaxSize']['maxSize'] | fileSizeConvert}}
                    </div>
                  }
                </div>
              }
            </div>
            <button appStopPropagation
              class="btn dnd-remove-button icon-close"
              type="button"
              (click)="onSelect(null)"
              title="Remove file">
            </button>
          </div>
        }
        <!-- Multi selected files -->
        @case (value && multiple) {
          <div class="dnd-info">
            <div class="dnd-icon-container">
              <i class="icon-doc"></i>
            </div>
            <div class="dnd-details">
              <div class="dnd-caption">{{value.length}} file{{value.length > 1 ? 's' : ''}} selected</div>
              <div class="dnd-description">
                <app-validation-error [errors]="ngControl.errors"></app-validation-error>
              </div>
            </div>
            <button appStopPropagation
              class="btn dnd-remove-button icon-close"
              type="button"
              (click)="onSelect(null)"
              title="Remove all files">
            </button>
          </div>
          @if (multiple) {
            <mat-chip-listbox class="mt-10" [selectable]="false">
              @for (file of value; track file) {
                <mat-chip-option [disableRipple]="true" class="pr-0" [class.invalid]="file['isInvalid']">
                  {{value['originalName'] || file.name}} ({{file.size | fileSizeConvert}})
                  <button appStopPropagation
                    class="btn dnd-remove-button icon-close"
                    type="button"
                    (click)="onSelect(null)"
                    title="Remove file">
                  </button>
                </mat-chip-option>
              }
            </mat-chip-listbox>
          }
        }
      }

    </div>
  </div>
